import { isoCountries } from '../countries-data-shared';

export const getFullCountryNameByCode = (countryCode?: string | null) => {
  if (!countryCode) {
    return undefined;
  }

  return isoCountries.getName(countryCode?.toLocaleUpperCase(), 'en');
};
